import http from '~/utils/http'

export function getClassRecord(page: number, size: number) {
  return http.get('/admin/class-record', {
    params: {
      page,
      size,
    },
  })
}

export function getClassRecordAttendanceMonthly(month: number) {
  return http.get('/admin/class-record/attendance-monthly', {
    params: {
      month,
    },
  })
}

export function getClassRecordAttendanceDetails(teacherId: string, month: number) {
  return http.get('/admin/class-record/attendance-details', {
    params: {
      teacherId,
      month,
    },
  })
}
